import { route } from "../../service/routeDictionary";
import API from "../../service/api";
import { environment } from "../../environments/env";

const state = {};

const getters = {};

const actions = {
  // eslint-disable-next-line no-unused-vars
  async resetPassword({ commit }, data) {
    return await API.put(`${environment.apiUri}${route.ResetPassword}`, data);
  },
};
const mutations = {};

export default {
  state,
  actions,
  getters,
  mutations,
};
